
<div>
    <div v-if = "header">
        <div class="navigation-header pr-2 panel-width">
            <div class = "navigation-col-header remove-button pl-4">
                <v-icon >mdi-trash-can-outline</v-icon>
            </div>
            <div class = "navigation-col-header elevator">
                {{ $t('inc.unit.elevatorNo') }}
            </div>
            <div class = "navigation-col-header executionDate pl-2">
                Ausf. Datum
            </div>
            <div class = "navigation-col-header description pl-2">
                {{ $t('inc.edit.general.description') }}
            </div>
            <div class = "navigation-col-header measure pl-2">
                {{ $t('inc.edit.general.measure') }}
            </div>
        </div>
    </div>

    <v-hover
        v-if   = "!header"
        v-slot = "{ hover }"
    >
        <div
            v-if="unit"
            class="navigation-entry panel-width"
            :class ="border2"
        >
            <div
                class="remove-button"
                :class = "background(hover)"
            >
                <a @click="onRemove">
                    <v-icon color="error" class="toolbar-button" size="20">mdi-minus-box</v-icon>
                </a>
            </div>
            <div
                class  = "elevator"
                :class = "background(hover)"
            >
                {{ unit.fabricNo }}
            </div>
            <div
                class  = "executionDate"
                :class = "background(hover)"
            >
                {{ executionDate }}
            </div>
            <div
                class  = "description"
                :class = "background(hover)"
            >
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            class="text-cell"
                            v-bind = "attrs"
                            v-on   = "on"
                        >
                            {{ description }}
                        </div>
                    </template>
                    <span v-html="description"></span>
                </v-tooltip>
            </div>
            <div
                class  = "measure"
                :class = "background(hover)"
            >
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            class="text-cell"
                            v-bind = "attrs"
                            v-on   = "on"
                        >
                            {{ measure }}
                        </div>
                    </template>
                <span v-html="measure"></span>
                </v-tooltip>
            </div>
        </div>
    </v-hover>
</div>
